
import {Apollo} from 'apollo-angular';
import {TypedDocumentNode} from "@apollo/client";
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable()
export class GraphqlService {
    constructor(private apollo: Apollo) {}

    query(gql: TypedDocumentNode, variables: any, forceReload: boolean): Observable<any> {
        return this.apollo.query<any>({
            fetchPolicy: forceReload ? 'network-only' : 'cache-first',
            query: gql,
            variables: variables
        }).pipe(map(res => {
            return res.data;
        }));
    }
}
